<template>
  <Header
    :headerModel="headerModel"
    @back-action="onBackRedirect"
    @tail-action="onTailAction"
  >
    <template #indicator>
      <div
        v-if="$settings.mode !== 'production'"
        class="sandbox-indicator"
        :class="`sandbox-indicator--${$isAndroid ? 'android' : 'ios'}`"
      ></div>
    </template>
  </Header>
</template>

<script>
import { isInternalLink } from "@/utils/links";
import { mapGetters, mapActions } from "vuex";
import Header from "@/components/shared/header/CommonHeader.vue";

export default {
  components: {
    Header,
  },
  computed: {
    ...mapGetters("system", {
      title: "getHeaderTitle",
      tail: "getHeaderTail",
    }),
    headerModel() {
      const model = {
        ...this.$route.meta,
        title: this.$gettext(this.title),
        tail: this.tail,
      };
      if (this.$isAndroid) {
        model.logo = "";
      }
      return model;
    },
    currentRoute() {
      return this.$route.name;
    },
  },
  methods: {
    ...mapActions("system", ["setHeaderTail", "setHeaderTitle"]),
    resetHeaderAction() {
      this.setHeaderTail(null);
    },
    onTailAction() {
      this.headerModel.tail.action();
    },
    onBackRedirect() {
      if (this.headerModel.backRoute === "default") {
        const originRoutePath = this.$route.path;
        // При редиректе назад срабатывает обычный переход назад и покидает страницу
        window.history.back();

        // Если он не сработал, и клиент остался на этой же странице,
        // срабатывает нативная функция
        setTimeout(() => {
          if (
            originRoutePath === this.$route.path &&
            window.mobapp?.onBackNavigation
          ) {
            window.mobapp.onBackNavigation();
          }
        }, 30);
        return;
      }

      if (isInternalLink(this.headerModel.backRoute)) {
        this.$router.replace(this.headerModel.backRoute);
      } else {
        window.location.href = this.headerModel.backRoute;
      }
    },
  },
  watch: {
    currentRoute() {
      this.setHeaderTitle(this.$route.meta.title);
      this.resetHeaderAction();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.sandbox-indicator {
  position: absolute;
  right: 0;
  top: 0;
  width: 0;
  height: 0;
  border-right: 35px solid rgba(#a8a8a8, 0.45);
  border-left: 48px solid transparent;
  border-bottom: 48px solid transparent;

  &::before {
    position: absolute;
    content: "SB";
    right: -30px;
    top: 5px;
    font-size: 12px;
    color: white;
    transform-origin: center;
    transform: rotate(60deg);
  }

  &--android {
    border-left: 56px solid transparent;
    border-bottom: 56px solid transparent;
  }
}
</style>
